import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import DataTable from '../DataTable';
import { toUtc } from '../../libs/date';

@inject('requestStore')
@observer
class RequestDetailOriginList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    requestStore: PropTypes.object.isRequired,
  }

  @observable originData = [];
  slug = '/request';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'timestamp', label: 'Timestamp' },
    { key: 'data_origin_parameter_code', label: 'Data Origin Parameter Code' },
    { key: 'flag', label: 'Flag' },
  ];

  componentWillMount() { this.reset(); }

  @action reset() {
    const { params: { id }, requestStore } = this.props;
    const request = requestStore.findById(id);
    const originData = (request && request.origin_data) || [];
    this.originData = originData.map(item => {
      return Object.assign({}, item, {
        timestamp: toUtc(item.timestamp),
      });
    });
  }

  render() {
    return (
      <DataTable
        data={this.originData}
        slug={this.slug}
        columns={this.columns}
        readOnly
      />
    );
  }
}

export default RequestDetailOriginList;



// WEBPACK FOOTER //
// ./src/components/Request/RequestDetailOriginDataList.js